(function () {
  'use strict';
  function init() {
    document.querySelectorAll('[data-vd-decal-designer]').forEach(function (root) {
      if (root.dataset.lengthControls) return;
      root.dataset.lengthControls = 'v1';
      var input = root.querySelector('[data-vd-width]');
      if (!input) return;
      var unit = input.closest('.vd-decal__unit-input') || input;
      var select = document.createElement('select');
      select.dataset.vdLengthPreset = '';
      select.setAttribute('aria-label', 'Choose length in inches');
      select.style.cssText = 'width:100%;min-width:0;min-height:48px;margin:0 0 8px;padding:10px 12px;border:1px solid #b9c0cf;border-radius:10px;background:#fff;color:#111;font:inherit;';
      var wrapper=document.createElement('label'),title=document.createElement('span');
      wrapper.style.cssText='display:block;margin:0 0 12px;';
      title.textContent='Quick length';title.style.cssText='display:block;font-weight:700;margin-bottom:8px;';
      wrapper.append(title,select);
      var grid=input.closest('.vd-decal__dimension-grid');
      if(grid)grid.parentNode.insertBefore(wrapper,grid);else unit.parentNode.insertBefore(wrapper,unit);
      var choices = [3,4,5,6,8,10,12,15,18,20,24,30,36,42,48,60,72,84,96,120,144,150,163];
      var signature = '', scheduled = false;
      function sync() {
        scheduled = false;
        // Keep API material values unchanged; only shorten visible text.
        var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), node;
        while ((node = walker.nextNode())) {
          if (/^\s*Specialty Colors?\s*$/.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace(/Specialty Colors?/, 'Specialty');
        }
        var unavailable = input.disabled || input.hidden || unit.hidden;
        if (select.hidden !== unavailable) select.hidden = unavailable;
        if (select.disabled !== unavailable) select.disabled = unavailable;
        if (wrapper.hidden !== unavailable) wrapper.hidden = unavailable;
        wrapper.style.display=unavailable?'none':'block';
        if (unavailable) return; // Existing exact-size menus remain authoritative.
        var min = Number(input.min) || 0, max = Number(input.max) || 150;
        var values = choices.concat([min, max]).filter(function (n) { return n >= min && n <= max && n >= 1; });
        values = Array.from(new Set(values)).sort(function(a,b){return a-b;});
        var next = values.join(',');
        if (signature !== next) {
          signature = next;
          select.replaceChildren();
          var custom = document.createElement('option');custom.value='custom';custom.textContent="Custom length - enter below";select.append(custom);
          values.forEach(function(n){var option=document.createElement('option');option.value=String(n);option.textContent=n+' inches';select.append(option);});
        }
        var current = String(Number(input.value));
        select.value = values.some(function(n){return String(n)===current;}) ? current : 'custom';
      }
      function schedule() { if (!scheduled) { scheduled=true;requestAnimationFrame(sync); } }
      select.addEventListener('change', function () {
        if (select.value === 'custom') {input.focus();input.select();return;}
        input.value = select.value;
        input.dispatchEvent(new Event('input',{bubbles:true}));
        input.dispatchEvent(new Event('change',{bubbles:true}));
        schedule();
      });
      root.addEventListener('input',schedule);root.addEventListener('change',schedule);
      root.addEventListener('click',function(){schedule();setTimeout(schedule,200);});
      new MutationObserver(schedule).observe(root,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['min','max','disabled','hidden']});
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init);else init();
})();
